export const checkFormValidation = (formData, requiredFields = []) => {
  return requiredFields.every((field) => {
    const value = formData[field];
    return value !== null && value !== undefined && String(value).trim() !== "";
  });
};

// function to format the date
export const formatCurrentDate = () => {
  return `Today (${new Date().toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })})`;
};

export const roleFlags = (role) => ({
  isAdmin: role === "admin",
  isStaff: role === "staff",
  isReceptionist: role === "receptionist",
  isDirector: role === "director",
});
